<template>
  <b-nav card-header tabs fill class="location-nav flex-wrap-reverse">
    <b-nav-item
      link-classes="location-nav-link"
      :to="{ name: 'LocationObservations', params: { id: $route.params.id } }"
      exact-active-class="active"
    >
      <i class="fa fa-binoculars mr-1 mr-lg-2"></i>
      Observations
    </b-nav-item>
    <b-nav-item
      link-classes="location-nav-link"
      :to="{ name: 'LocationTrends', params: { id: $route.params.id } }"
      exact-active-class="active"
    >
      <i class="fa fa-chart-line mr-1 mr-lg-2"></i>
      Trends
    </b-nav-item>

    <b-nav-item-dropdown
      v-if="isManager"
      :toggle-class="isManageActive"
      :class="{ 'location-nav-link-manager': isManager }"
      right
    >
      <template #button-content>
        <i class="fa fa-thumb-tack mr-1"></i>
        <i class="fa fa-edit mr-1"></i>
        <i class="fa fa-trash mr-1 mr-lg-2"></i>
        Manage
      </template>
      <b-dropdown-item
        :to="{ name: 'LocationAssignments', params: { id: $route.params.id } }"
        exact-active-class="active"
      >
        <i class="fa fa-thumb-tack mr-1 mr-lg-2"></i>Assignments
      </b-dropdown-item>
      <b-dropdown-item
        :to="{ name: 'LocationEdit', params: { id: $route.params.id } }"
        exact-active-class="active"
      >
        <i class="fa fa-edit mr-1 mr-lg-2"></i>Edit
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item
        :to="{ name: 'LocationDelete', params: { id: $route.params.id } }"
        exact-active-class="active"
      >
        <i class="fa fa-trash mr-1 mr-lg-2"></i>Delete
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LocationNavigation",
  computed: {
    ...mapGetters({
      isMember: "location/isMember",
      isManager: "location/isManager",
      location: "location/details",
    }),
    isManageActive() {
      const manageTabs = [
        "LocationMembers",
        "LocationDatasheets",
        "LocationEdit",
        "LocationDelete",
      ];
      if (manageTabs.includes(this.$route.name)) {
        return "active";
      }
      return "location-nav-link";
    },
  },
};
</script>

<style lang="scss" scoped>
.location-nav-link {
  /*letter-spacing: -1px;*/
  color: #3b3b3b;
  /* 7E7E7E BDBDBD 22252C */
  /*font-weight: bold; */

  &:hover {
    color: #007fb1;
  }
}

.location-nav-link-manager {
  background-color: #ffd966;

  &:active {
    /*background-color: #000000*/
  }
}
</style>
